<template>
    <CompassModal
        v-model:visible="showModal"
        class="activities-listing-mass-modify-owner"
        size="small"
        :closeOnClickOverlay="false"
        :title="$t.__('activities.listing.massActions.ActivitiesListingMassActions.modify_owner')"
        :primaryAction="{
            label: $t.__('common.actions.confirm'),
            disabled: isConfirmButtonDisabled,
            action: () => confirmMassModifyOwner(),
            loading: isSubmitting,
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                disabled: isSubmitting,
                action: () => $emit('close'),
            },
        ]"
        @closed="$emit('close')"
    >
        <span class="typographies-paragraph-medium-bold">
            {{ $t.__('common.labels.staff') }}
        </span>
        <CompassSelect
            v-model="selectedOwner"
            :placeholder="$t.__('common.actions.select_staff')"
            filterable
            menuClass="activities-listing-mass-assign-owner-select-menu"
        >
            <CompassDropdownOption
                v-for="staff in metas.authors"
                :key="staff.id"
                :label="getFullNameUser(staff)"
                :value="staff.id"
                type="avatar"
                :avatar="formatUserToCompassAvatar(staff)"
            />
        </CompassSelect>
    </CompassModal>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { massModifyOwner } from 'api/activities/activitiesMassActionsService';
const { mapGetters: activitiesMapGetters } = createNamespacedHelpers('activitiesStores');
import { formatUserToCompassAvatar, getFullNameUser } from 'Helpers/avatarHelper';
export default {
    props: {
        selectedActivities: {
            type: Array,
            default: () => [],
        },
        onError: {
            type: Function,
            default: () => {},
        },
        onSuccess: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            showModal: true,
            selectedOwner: 0,
            isSubmitting: false,
        };
    },
    computed: {
        ...activitiesMapGetters({ metas: 'getMetas' }),
        isConfirmButtonDisabled() {
            return this.selectedOwner === null;
        },
    },
    methods: {
        formatUserToCompassAvatar,
        getFullNameUser,
        async confirmMassModifyOwner() {
            try {
                this.isSubmitting = true;
                await massModifyOwner(this.selectedActivities, this.selectedOwner);
                this.$emit('close');
                this.onSuccess();
            } catch (error) {
                this.onError(error);
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
<style lang="scss">
.activities-listing-mass-modify-owner {
    .compass-modal__modal__content {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-0);
    }
}

#compass-dropdown-container {
    .activities-listing-mass-assign-owner-select-menu {
        z-index: 1001;
    }
}
</style>
